import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchEmployees,
  fetchEmployeeByUiid,
  addNewEmployee,
  updateEmployee,
  bulkUpdateEmployee,
} from "./employeeApi";
import {
  getEmployeesStart,
  getEmployeesSuccess,
  getEmployeesFailure,
  ///
  getEmployeeByUiidStart,
  getEmployeeByUiidSuccess,
  getEmployeeByUiidFailure,
  ///
  addNewEmployeeStart,
  addNewEmployeeSuccess,
  addNewEmployeeFailure,
  //
  updateEmployeeStart,
  updateEmployeeSuccess,
  updateEmployeeFailure,
  bulkUpdateEmployeeStart,
  bulkUpdateEmployeeSuccess,
  bulkUpdateEmployeeFailure,
} from "./employeeSlice";
import { showToast } from "../../../components";

function* fetchEmployeesSaga(action) {
  try {
    //console.log("action", action);
    const employees = yield call(fetchEmployees, action.payload);
    yield put(getEmployeesSuccess(employees));
  } catch (error) {
    yield put(getEmployeesFailure(error));
  }
}

function* fetchEmployeeByUiidSaga(action) {
  try {
    const { uiid, tab, ret, ref } = action.payload;
    // const employee = yield call(fetchEmployeeByUiid, { uiid, ret, ref });
    const employee = yield call(fetchEmployeeByUiid, action.payload);
    yield put(getEmployeeByUiidSuccess({ data: employee.data, tab }));
  } catch (error) {
    yield put(getEmployeeByUiidFailure(error.message));
  }
}

function* addNewEmployeeSaga(action) {
  try {
    const { submissionData, navigate } = action.payload;
    //console.log("submissionData", submissionData, "navigate", navigate);
    const response = yield call(addNewEmployee, submissionData);

    if (response.success) {
      yield put(addNewEmployeeSuccess(response.data));
      showToast("New Employee Added", "success", 5000);
      navigate("/employee");
    } else {
      yield put(addNewEmployeeFailure(response.error));
      //console.log("response", response);
      showToast(`${response.error}`, "error", 5000);
    }
  } catch (error) {
    yield put(addNewEmployeeFailure(error.message));
    showToast(`${error.message || "Failed to add new employee"}`, "error", 5000);
  }
}

function* updateEmployeeSaga(action) {
  try {
    const { onSuccess, tab, ret, ...payload } = action.payload;
    const response = yield call(updateEmployee, payload);

    if (response.success) {
      if (onSuccess) {
        //onSuccess();
        onSuccess(response.data);
      }
      //yield put(updateEmployeeSuccess(response.data));
      yield put(updateEmployeeSuccess(response.data.data.doc));
      showToast("Updated Employee details successfully", "success");
      // yield put(
      //   getEmployeeByUiidStart({
      //     uiid: payload.uiid,
      //     tab: tab || "overview", // Default to overview if not specified
      //     ret: ret || "uiid firstName lastName email", // Default fields if not specified
      //   })
      // );
    } else {
      yield put(updateEmployeeFailure(response.error));
      showToast("Failed to update employee", "error");
    }
  } catch (error) {
    yield put(updateEmployeeFailure(error.message));
    showToast("Error updating employee", "error");
  }
}
function* bulkUpdateEmployeeSaga(action) {
  try {
    const { onSuccess, tab, ret, ...payload } = action.payload;
    const response = yield call(bulkUpdateEmployee, payload);

    if (response.success) {
      if (onSuccess) {
        //onSuccess();
        onSuccess(response.data);
      }
      //yield put(updateEmployeeSuccess(response.data));
      yield put(bulkUpdateEmployeeSuccess(response.data.data.doc));
      showToast("Updated Employee details successfully", "success");
      // yield put(
      //   getEmployeeByUiidStart({
      //     uiid: payload.uiid,
      //     tab: tab || "overview", // Default to overview if not specified
      //     ret: ret || "uiid firstName lastName email", // Default fields if not specified
      //   })
      // );
    } else {
      yield put(bulkUpdateEmployeeFailure(response.error));
      showToast("Failed to update employee", "error");
    }
  } catch (error) {
    yield put(bulkUpdateEmployeeFailure(error.message));
    showToast("Error updating employee", "error");
  }
}

export function* watchFetchEmployees() {
  yield takeLatest(getEmployeesStart.type, fetchEmployeesSaga);
  yield takeLatest(getEmployeeByUiidStart.type, fetchEmployeeByUiidSaga);
  yield takeLatest(addNewEmployeeStart.type, addNewEmployeeSaga);
  yield takeLatest(updateEmployeeStart.type, updateEmployeeSaga);
  yield takeLatest(bulkUpdateEmployeeStart.type, bulkUpdateEmployeeSaga);
}
